import React, {useEffect, useState} from 'react';
import {
  SafeAreaView,
  View,
  TouchableOpacity,
  Text,
  StyleSheet,
  ScrollView,
  Platform,
} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import FastImage from '../../../common/FastImage';
import {Button} from '../../../components/core/Button';
import {
  globalConfigurableData,
  globalConst,
} from '../../../utils/globalConstant';
import {wallet_success} from '../../../utils/images';
import {Network} from '../../../utils/network';
import {useToast} from '../../../components/core/Toast';
import {convert} from '../../../locale/translateText';
import {getUser} from '../../Profile/redux/profile.action';
import { Icon } from '@iconify/react';

const listOptions = [
  {
    range: '0-100',
    description: 'Prices will be displayed within 0-100 price range',
    example: 'Event prices can be 1, 2, 3 ... 97, 98, 99',
  },
  {
    range: '0-100',
    description: 'Prices will be displayed within 0-100 price range',
    example: 'Event prices can be 1, 2, 3 ... 97, 98, 99',
  },
  {
    range: '0-100',
    description: 'Prices will be displayed within 0-100 price range',
    example: 'Event prices can be 1, 2, 3 ... 97, 98, 99',
  },
];

const PriceSelection = ({navigation}) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const dispatch = useDispatch();
  const { toast } = useToast();
  const onOptionClick = item => {
    setSelectedIndex({start: item?.start, end: item?.end});
  };
  let userInfo = useSelector(({profile}) => profile?.profileData);

  useEffect(() => {
    if (userInfo && userInfo?.range_preference?.end !== selectedIndex) {
      setSelectedIndex(userInfo?.range_preference);
    }
  }, [userInfo]);

  const onPriceSelectionConfirm = async () => {
    const res = await Network.setPriceRange(selectedIndex, true);
    if (res?.data?.success) {
      dispatch(getUser());
      toast({
        title: convert('Price Range Changed successfully'),
        variant: 'info'
      });
    }
  };

  return (
    <SafeAreaView style={[{flexGrow: 1}]}>
      <ScrollView
        style={globalStyle.pageContainer}
        overScrollMode="never"
        nestedScrollEnabled={Platform.OS === 'web' ? false : true}
        keyboardShouldPersistTaps={'handled'}
        //style={{width: '100%'}}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{
          flexGrow: 1,
          //paddingBottom: globalImport?.isWeb ? 50 : 150,
        }}>
        <View style={{paddingHorizontal: 16, flexGrow: 1}}>
          <TouchableOpacity onPress={() => navigation.goBack()}>
            <Icon 
              icon="tabler:arrow-left"
              style={{ width: 24, height: 24 }}
              color={globalConfigurableData.primaryTextColor1}
            />
          </TouchableOpacity>
          <View style={{flex: 1, justifyContent: 'space-between'}}>
            <View>
              <View style={{marginBottom: 35, marginTop: 25}}>
                <Text style={globalFontStyle.appFontHeading}>
                  Select your preferred price view
                </Text>
                <Text
                  style={[
                    globalFontStyle.appFontSubText,
                    {color: Colors.grey2},
                  ]}>
                  You can always change your language from accounts section
                </Text>
              </View>
              {userInfo?.range_options?.map((item, index) => {
                const isSelected = selectedIndex?.end === item?.end;
                return (
                  <TouchableOpacity
                    key={index}
                    onPress={() => {
                      onOptionClick(item);
                    }}>
                    <View>
                      <View
                        style={{
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }}>
                        <View style={{flex: 1}}>
                          <Text style={globalFontStyle.appFontSubHeading}>
                            {item?.start}-{item?.end}
                          </Text>
                          <Text
                            style={[
                              globalFontStyle.appFontSubText,
                              {color: Colors.grey2, marginVertical: 4},
                            ]}>
                            {item?.description}
                          </Text>
                        </View>
                        {isSelected && (
                          <View>
                            <FastImage
                              style={{width: 26, height: 26}}
                              source={wallet_success()}
                            />
                          </View>
                        )}
                      </View>
                      <View
                        style={[
                          styles.elementParent,
                          isSelected
                            ? {backgroundColor: 'rgba(10, 87, 255, 0.10)'}
                            : null,
                        ]}>
                        <Text
                          style={[
                            globalFontStyle.appFontSmallText,
                            isSelected ? {color: '#0A57FF'} : null,
                          ]}>
                          {item?.sample}
                        </Text>
                      </View>
                    </View>
                    <View style={styles.borderUnderline} />
                  </TouchableOpacity>
                );
              })}
            </View>
            <View>
              <View style={styles.elementParent}>
                <Text
                  style={[
                    globalFontStyle.appFontSmallText,
                    {color: Colors.grey2},
                  ]}>
                  Prices for the selected view will gets adjusted based on event
                  ticker sizes
                </Text>
              </View>

              <View>
                <Button
                  variant="primary"
                  onPress={() => {
                    setTimeout(() => {
                      onPriceSelectionConfirm();
                    }, globalConst?.buttonTimer);
                  }}
                  translate={true}
                  style={{marginVertical: 15}}
                >
                  Continue
                </Button>
              </View>
            </View>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default PriceSelection;

const styles = StyleSheet.create({
  elementParent: {
    paddingHorizontal: 7,
    paddingVertical: 10,
    borderRadius: 5,
    backgroundColor: '#F4F4F4',
  },
  borderUnderline: {
    borderBottomWidth: 1,
    borderColor: '#E2E2E2',
    marginVertical: 14,
  },
});
